module.exports = __webpack_public_path__ + "img/newicon2.f9ffb58f.png";